import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { HookFormSimpleSelect } from 'components/settings/components/sections/dixaMessenger/views/flow/components/nodeTypeChatBot/chatBotModal/components/HookSimpleSelect';
import { useChatBots } from 'hooks/useChatBots';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
function findItemNameById(id, items) {
    var _a;
    const item = items.find((i) => i.id === id);
    return (_a = item === null || item === void 0 ? void 0 : item.name) !== null && _a !== void 0 ? _a : '';
}
export const ChatbotModal = (props) => {
    const { node, nodeLabel, triggerClose, replaceNode } = props;
    const { items, asyncStatus } = useChatBots();
    const chatBotName = node.payload
        ? findItemNameById(node.payload.chatbotId, items)
        : '';
    const defaultValues = node.payload
        ? { chatbot: { id: node.payload.chatbotId, name: chatBotName } }
        : undefined;
    const { control, formState, handleSubmit } = useForm({
        defaultValues: defaultValues,
    });
    const closeModal = useCallback(triggerClose, [triggerClose]);
    const notify = useNotifications();
    const handleSaveClick = useCallback((values) => {
        var _a, _b;
        if (!values.chatbot) {
            notify({ title: 'Please enter a chatbot ID' }, NotificationType.Error);
            return;
        }
        const successNextNodeId = ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.successNextNodeId) || uuid();
        const failNextNodeId = ((_b = node.payload) === null || _b === void 0 ? void 0 : _b.failNextNodeId) || uuid();
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], icon: '', text: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.MESSENGER_CHAT_BOT, payload: {
                chatbotName: findItemNameById(values.chatbot.id, items),
                chatbotId: values.chatbot.id,
                successNextNodeId,
                failNextNodeId,
            }, overlay: [] });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, replaceNode, triggerClose, notify, items]);
    const disabledSubmit = !formState.isDirty;
    const isLoadingItems = asyncStatus === 'loading';
    const chatBotListIsEmpty = items.length === 0;
    const hasNoChatBotsDefined = chatBotListIsEmpty && !isLoadingItems;
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: closeModal }, { children: "Choose your existing chatbot integration from the list below. When this node is activated, the chabot will initiate a conversation with the user, offering the pre-set options made on its configuration. The next steps must be set for each chatbot outcome." })), _jsx(ModalBody, { children: _jsxs("form", Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [!hasNoChatBotsDefined && (_jsx(HookFormSimpleSelect, { control: control, name: "chatbot", label: "Select your chatbot integration", rules: { required: 'Chatbot is required' }, componentProps: {
                                items,
                                loading: isLoadingItems,
                                renderSelection: ({ id }) => findItemNameById(id, items),
                            } })), hasNoChatBotsDefined && (_jsxs(Text.Paragraph, Object.assign({ color: colors.orange[900] }, { children: ["Make sure you have added a chatbot integration in the", ' ', _jsx(Link, Object.assign({ to: "/settings/integrations" }, { children: "settings" }))] })))] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: {
                    disabled: disabledSubmit || isLoadingItems,
                    isLoading: isLoadingItems,
                }, cancelOnClick: closeModal })] })));
};
